import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  const appointmentLink = "https://nextcloud.managershop.com/index.php/apps/appointments/pub/39t5c1133b0ztr29/form";

  return (
    <section className="pt-32 pb-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-4xl md:text-6xl font-bold mb-8 leading-tight">
              <span className="text-black">Gute System-Architektur.</span><br />
              <span className="text-azure-600">Klare Automatisierung.</span><br />
              <span className="text-emerald-600">Skalierbare Ergebnisse.</span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 mb-12 leading-relaxed max-w-3xl mx-auto">
              KI beschleunigt nur das, was bereits vorhanden ist. Wir entwerfen die System-Architektur, damit Ihre Prozesse auf einem stabilen Fundament stehen.
            </p>
            <div className="flex flex-col items-center gap-4">
              <a
                href={appointmentLink}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto bg-black text-white px-10 py-4 rounded-lg text-lg font-bold hover:bg-gray-800 transition-all shadow-lg"
              >
                Kostenloses Erstgespräch buchen
              </a>
              <p className="text-sm text-gray-500 font-medium italic">
                15 Minuten. Orientierung statt Verkauf.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;